<template>
  <div class="wrapper">
    <label
      v-for="(value, label, i) in items"
      :key="`${id}-${i}`"
      :for="`${id}-${i}`"
      :title="label">
      <input
        type="radio"
        :id="`${id}-${i}`"
        :checked="selected === value"
        :value="value"
        @change="$emit('update:selected', value, $event)">
      <span
        class="after-focus:border-blue-300 after-focus:shadow"
        :class="{'selected': selected === value}">
        {{ label }}
      </span>
    </label>
  </div>
</template>

<script>
import { randomString } from '../helpers.js';

export default {
  props: {
    items: {
      type: Object,
      default: () => {
        return {
          'Yes': true,
          'No': false,
        };
      },
    },
    selected: null,
  },

  data() {
    return {
      id: '',
    };
  },

  created() {
    this.id = this.randomString(24);
  },

  methods: {
    randomString,
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
}

label {
  cursor: pointer;
  position: relative;
}

label + label {
  margin-left: -2px;
}

label > input {
  opacity: 0;
  position: absolute;
}

label > span {
  align-items: center;
  background-color: #dbd8d4;
  border: 1px solid transparent;
  color: #343434;
  display: flex;
  height: 2.5em;
  justify-content: center;
  position: relative;
  width: 4em;
}

label:first-child > span {
  border-radius: .25em 0 0 .25em;
}
label:last-child > span {
  border-radius: 0 .25em .25em 0;
}

label:hover > span {
  border-color: #909090;
  box-shadow: 0 0 0.5em 0.2em rgba(122,122,122,.2);
}

input:focus + span {
  border-color: #00549d;
  box-shadow: inset 0 0.2em 0.5em rgba(0,0,0,.09),
              0 0 0.5em 0.1em rgba(0,84,157,.75);
}

.selected {
  background-color: #FFF;
  border-color: #909090;
  color: #1a202c;
  z-index: 10;
}
</style>